import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as pkLang } from './core/_config/i18n/pk';
// import { locale as esLang } from './core/_config/i18n/es';
// import { locale as jpLang } from './core/_config/i18n/jp';
// import { locale as deLang } from './core/_config/i18n/de';
// import { locale as frLang } from './core/_config/i18n/fr';
import { DOCUMENT } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GoogleAnalyticsService } from './shared/sharedServices/google-analytics.service';
import { decrypt, encrypt } from './utilities/utilityFunctions';
import { Idle } from '@ng-idle/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material';
@Component({
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'E-Services';
	loader: boolean;
	public message;
	public deviceInfo = null;
	public isDesktopUser: boolean;
	public isiOSUser: boolean;
	public isAndroidUser: boolean;
	public isUseWebsite:boolean;
	private unsubscribe: Subscription[] = []; 
	@ViewChild('detection', { static: false }) detection: ElementRef;

	constructor(private translationService: TranslationService,
		private router: Router,
		private deviceService: DeviceDetectorService,
		private layoutConfigService: LayoutConfigService,
		private gaService: GoogleAnalyticsService,
		private idle: Idle,
		private dialog: MatDialog,private modalService:NgbModal,
		@Inject(DOCUMENT) private windowDoc: Document,
		private splashScreenService: SplashScreenService) {
		// document.addEventListener('contextmenu', event => event.preventDefault());
		if(localStorage.getItem('isUseWebsite') && decrypt(localStorage.getItem('isUseWebsite'))=='1'){
			this.isUseWebsite = true;
		}
		if(!this.isUseWebsite){
		this.deviceCheck();
	}
		this.gaService.init();
		// this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
		this.translationService.loadTranslations(enLang,pkLang);
	}

	ngOnInit(): void {
		this.loader = this.layoutConfigService.getConfig('loader.enabled');
		
		
		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.splashScreenService.hide();
				window.scrollTo(0, 0);
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
		});
		this.unsubscribe.push(routerSubscription);		

		setInterval(()=>{
			this.checkLoginStatus();
		}, 2000);

	
	}

	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}

	deviceCheck() {
		this.deviceInfo = this.deviceService.getDeviceInfo();
		if (this.deviceInfo.os == 'iOS') {
			this.isiOSUser = true;
			this.isAndroidUser = false;
			localStorage.setItem('agent', encrypt('ios'))
		} else if (this.deviceInfo.os == 'Android') {
			this.isAndroidUser = true;
			this.isiOSUser = false;
			localStorage.setItem('agent', encrypt('android'))

		}
		const isMobile = this.deviceService.isMobile();
		const isTablet = this.deviceService.isTablet();
		this.isDesktopUser = this.deviceService.isDesktop();
		if (this.isDesktopUser)
			localStorage.setItem('agent', encrypt('desktop'))
	}

	public useWebsite() {
		localStorage.setItem('isUseWebsite', encrypt('1'));
		this.isUseWebsite = true;
		this.isAndroidUser = false;

	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
	  }

	  public checkLoginStatus(): void {
		window.addEventListener('storage', (event) => {
			if (event.storageArea == localStorage) {
				let token = localStorage.getItem('esp-profile-details');
				if(token == null) {
						this.idle.stop();
						this.dialog.closeAll();
          				this.modalService.dismissAll()
						window.location.href='/#/auth/login'  // If you are using router
						
				}else if(this.router.url){
					this.router.navigate([this.router.url])
				}
				else{
					window.location.href='/#/dashboard'  // If you are using router

				}
			}
		}, false);

		
	}

	public checkConsole():any{
		// !function():any {
		// 	function detectDevTool(allow?) {
		// 	  if(isNaN(+allow)) allow = 100;
		// 	var start = +new Date();
		// 	debugger;
		// 	var end = +new Date();
		// 	if(isNaN(start) || isNaN(end) || end - start > allow) {
		// 		alert('DEVTOOLS detected. all operations will be terminated.');
		// 	  document.write('DEVTOOLS detected.');
		// 	}
		//   }
		//   if(this.windowDoc.attachEvent) {
		// 	  if (document.readyState === "complete" || document.readyState === "interactive") {
		// 		detectDevTool();
		// 		this.windowDoc.attachEvent('onresize', detectDevTool);
		// 		this.windowDoc.attachEvent('onmousemove', detectDevTool);
		// 		this.windowDoc.attachEvent('onfocus', detectDevTool);
		// 		this.windowDoc.attachEvent('onblur', detectDevTool);
		// 	} else {
		// 		// setTimeout(callback2(), 0);
		// 	}
		//   } else {
		// 	this.windowDoc.addEventListener('load', detectDevTool);
		// 	this.windowDoc.addEventListener('resize', detectDevTool);
		// 	this.windowDoc.addEventListener('mousemove', detectDevTool);
		// 	this.windowDoc.addEventListener('focus', detectDevTool);
		// 	this.windowDoc.addEventListener('blur', detectDevTool);
		//   }
		// }();
	}


	public goToDownload():void{
		window.open('https://play.google.com/store/apps/details?id=com.system.dasapp')
	}

	

}
